// src/contexts/LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { SUPPORTED_LANGUAGES } from '../utils/translationService';

// Create language context
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Default language is English
  const [currentLanguage, setCurrentLanguage] = useState(SUPPORTED_LANGUAGES.ENGLISH);
  
  // Check localStorage for saved language preference on initial load
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage) {
      try {
        const parsedLanguage = JSON.parse(savedLanguage);
        // Validate that it's a supported language
        if (Object.values(SUPPORTED_LANGUAGES).some(lang => lang.code === parsedLanguage.code)) {
          setCurrentLanguage(parsedLanguage);
        }
      } catch (error) {
        console.error('Error parsing saved language preference:', error);
      }
    }
  }, []);

  // Change language function
  const changeLanguage = (languageObj) => {
    setCurrentLanguage(languageObj);
    localStorage.setItem('preferredLanguage', JSON.stringify(languageObj));
  };

  return (
    <LanguageContext.Provider value={{ 
      currentLanguage, 
      changeLanguage,
      supportedLanguages: SUPPORTED_LANGUAGES
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};